import React, { FC, useEffect } from 'react';
import { PinType } from 'types/ApiTypes';
import { redirectTo } from 'utils/fnSettings';
import { PageWrapper } from 'components/Pages/Settings/PageSettingsCommon.css';
import translate from 'utils/fnTranslate';
import { useApp } from 'providers/useApp/AppContext';
import { HelmetWrapper } from 'components/HelmetWrapper/HelmetWrapper';
import { getHelmetData } from 'utils/fnHelmet';
import { PinFlowType, usePin } from 'providers/usePin/PinContext';
import { useConfig } from 'providers/useConfig/ConfigContext';
import OptionFocusable from 'components/Pages/Settings/OptionFocusable';
import { PageHeading } from 'components/PageHeading/PageHeading.css';

const PagePinProtection: FC = () => {
    const { setPageTitle } = useApp();
    const { openPinDialog } = usePin();
    const { config } = useConfig();
    const { reset } = config?.api_config?.routes?.Pin ?? {};

    useEffect(() => {
        setPageTitle(translate('SETTINGS_PIN'));
    }, []);

    return (
        <HelmetWrapper {...getHelmetData(translate('SETTINGS_PIN'))}>
            <PageWrapper>
                <PageHeading srOnly>{translate('SETTINGS_PIN')}</PageHeading>
                <OptionFocusable
                    title={translate('SETTINGS_CHANGE_PURCHASE_PIN')}
                    onClick={() => openPinDialog(PinFlowType.CHANGE, PinType.PURCHASE)}
                    role="button"
                />
                <OptionFocusable title={translate('SETTINGS_FORGOT_YOUR_PIN')} onClick={() => redirectTo(reset)} isExternalLink />
            </PageWrapper>
        </HelmetWrapper>
    );
};

export default PagePinProtection;
